<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-9">
            <profile-settings v-if="hash === 'profile' || !hash" v-model:user="currentUser"></profile-settings>

            <teams-settings v-if="hash === 'teams'" :user="props.user" :teams="props.teams"></teams-settings>

            <notification-settings v-if="hash === 'notifications'"></notification-settings>

            <invites-settings v-if="hash === 'invites'" />

            <sessions-settings v-if="hash === 'sessions'" />

            <security-settings v-if="hash === 'security' && props.user.auth.password_usable" :user="props.user" />

            <api-settings v-if="onCorporate() && hash === 'api' && props.user.auth.password_usable"></api-settings>
        </div>
    </page-container>
</template>

<script setup>
import PageContainer from '~/components/general/PageContainer.vue';
import ProfileSettings from '../profile/ProfileSettings.vue';
import InvitesSettings from '../invites/InvitesSettings.vue';
import TeamsSettings from '../teams/TeamsSettings.vue';
import NotificationSettings from '../notifications/NotificationSettings.vue';
import SessionsSettings from '../sessions/SessionsSettings.vue';
import SecuritySettings from '../security/SecuritySettings.vue';
import ApiSettings from '../api/ApiSettings.vue';
import { ref } from 'vue';
import SettingsSidebar from './SettingsSidebar.vue';
import { useBrowserLocation } from '@vueuse/core';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import { useSettingsHash } from '~/composables/useSettingsHash';

const props = defineProps({
    user: Object,
    teams: Object,
});

const { onCorporate } = useCurrentGroup();

const currentUser = ref({ ...props.user });

const location = useBrowserLocation();
const { hash, content } = useSettingsHash();

if (!hash.value) {
    // A login between the invitation email and this page drops the link's hash.
    location.value.hash = new URLSearchParams(location.value.search).has('invitation') ? '#/invites' : '#/profile';
}
</script>
